document.addEventListener('DOMContentLoaded', () => {

    //https://github.com/geosigno/simpleParallax.js/#settings
    new simpleParallax(document.querySelectorAll(`.parallax--1 .parallax-item, .parallax--3 .parallax-item`), {
        delay: 0,
        orientation: 'up',
        scale: 1.5,
        overflow: true
    });

    new simpleParallax(document.querySelectorAll(`.parallax--4 .parallax-item`), {
        delay: 0,
        orientation: 'up',
        scale: 2,
        overflow: true
    });

    new simpleParallax(document.querySelectorAll(`.parallax--2 .parallax-item`), {
        delay: 0,
        orientation: 'up',
        scale: 1.25,
        overflow: true
    });

});